import React, {
    memo,
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";
import CommonHeader from "../../CommonHeader";
import {
    Button,
    Card,
    Col,
    Icon,
    Input,
    Pagination,
    Row,
    Select,
    Spin,
    Radio,
} from "antd";
import CustomAgGridTable from "../../../../Common-Table/CustomAgGridTable";
import CustomHeader from "../../../../CommonHeader/CustomHeader";
import { use } from "react";
import { Translate } from "react-translated";
import arrowIcon from "../../../../assets/icons/svg/arrow-icon.svg";
import WeeklyStatModal from "./WeeklyStatModal";
import {
    FS_APPOINTMENT_REPORT,
    GET_FS_ALL_AGENCIES,
    RS_ALL_AGENCIES_API_URL,
    RS_APPOINTMENT_REPORT,
} from "../../../../utils/Api_enums";
import axios from "axios";
import {
    EA,
    FOLLOW_UP_SPECIALIST,
    FOLLOWUP,
    LEAD,
    OPPORTUNITY,
    PROSPECT,
    REVIEW_SCHEDULER,
    REVIEWADMIN,
    type_of_call_format,
    TYPE_TO_FILTER_BY_NAME,
} from "../../../../utils/Constants";
import F from "../../../../Functions";
import moment from "moment";
import { useBoundStore } from "../../../../store/useBoundStore";

const { Option } = Select;

const WeeklyMonthlyReport = (props) => {
    const [queryParams, setQueryParams] = useState({
        sortField: null,
        sortDirection: null,
        filters: {}
    });
    const [toggleAdminSwitchRole, setAdminToggleSwitchRole] = useState("Lead");
    const { RSFSCardFilters, setRSFSFilters } = useBoundStore();
    const [selectedAgency, setSelectedAgency] = useState(undefined);
    const [agencies, setAgencies] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const monthOptions = Array.isArray(F.getMonths()) ? F.getMonths() : [];
    const carrierOptions = Array.isArray(F.getCarriers()) ? F.getCarriers() : [];
    //const [role, setRole] = useState(props.auth?.user?.role);
    const [role, setRole] = useState(RSFSCardFilters.selectedAdminToggle);
    const [selectedMonth, setSelectedMonth] = useState(moment().format("M"));
    const [selectedCarrier, setSelectedCarrier] = useState("All Carrier");
    const [loading, setLoading] = useState(false);
    const [sortOrders, setSortOrders] = useState({});
    // const [columnDefs, setColumnDefs] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [gridApi, setGridApi] = useState(null);
    const [columnApi, setColumnApi] = useState(null);
    const pageSize = 10;
    const [gridKey, setGridKey] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalData, setModalData] = useState(null);
    const resetHandlers = useRef([]);
    const searchTimeout = useRef(null);

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleFilterResetHandler = (resetFn) => {
        resetHandlers.current.push(resetFn);
    };

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleSearch = (e) => {
        setSearchText(e.target.value);
    };
    const filterTimeout = useRef(null);

    const handleFilter = (field, value, inputType = "text") => {
        setCurrentPage(1);

        // instant filters
        if (inputType !== "text") {
            setQueryParams((prev) => {
                if (field === "agency_name") {
                    setSelectedAgency(value);
                    return { ...prev, filters: {} };
                }

                if (field === "carrier") {
                    setSelectedCarrier(value);
                    return { ...prev, filters: {} };
                }

                return {
                    ...prev,
                    filters: value ? { [field]: value } : {},
                };
            });

            return;
        }

        // debounce only text filters
        clearTimeout(filterTimeout.current);

        filterTimeout.current = setTimeout(() => {
            setQueryParams((prev) => ({
                ...prev,
                filters: value ? { [field]: value } : {},
            }));
        }, 300);
    };


    // const handleFilter = (field, value) => {
    //     setQueryParams((prev) => {
    //         if (field === "agency_name") {
    //             setSelectedAgency(value);
    //             return { ...prev, filters: {} };
    //         } else if (field === "carrier") {
    //             setSelectedCarrier(value);
    //             return { ...prev, filters: {} };
    //         }

    //         return {
    //             ...prev,
    //             filters: value ? { [field]: value } : {}
    //         };
    //     });

    //     setCurrentPage(1);
    // };

    const handleSort = (field) => {
        setLoading(true);

        setQueryParams((prev) => {
            const currentOrder = prev.sortField === field ? prev.sortDirection : "asc";
            const newOrder = currentOrder === "asc" ? "desc" : "asc";

            const updated = {
                ...prev,
                sortField: field,
                sortDirection: newOrder
            };

            setCurrentPage(1);

            fetchReport(
                role,
                selectedMonth,
                selectedCarrier,
                searchText,
                selectedAgency,
                toggleAdminSwitchRole,
                updated.sortField,
                updated.sortDirection,
                updated.filters
            );

            return updated; //updated react state
        });
    };

    const handleRoleSwitchChange = (fsRole) => {
        setAdminToggleSwitchRole(fsRole);
        console.log("Role switched to:", fsRole);
        fetchReport(
            "EA",
            selectedMonth,
            selectedCarrier,
            searchText,
            selectedAgency,
            fsRole,
        );
    };

    const ArrowIconRenderer = memo((props) => {
        return (
            <img
                src={arrowIcon}
                alt="arrow"
                style={{
                    width: "16px",
                    height: "16px",
                    cursor: "pointer",
                }}
                onClick={() => {
                    setIsModalOpen(true);
                    setModalData(props.data);
                }}
            />
        );
    });

    useEffect(() => {
        fetchReport(
            role,
            selectedMonth,
            selectedCarrier,
            searchText,
            selectedAgency,
            toggleAdminSwitchRole,
            queryParams.sortField,
            queryParams.sortDirection,
            queryParams.filters
        );
    }, [
        role,
        selectedMonth,
        selectedCarrier,
        searchText,
        selectedAgency,
        toggleAdminSwitchRole,
        queryParams
    ]);

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            fetchReport(
                role,
                selectedMonth,
                selectedCarrier,
                searchText,
                selectedAgency,
                toggleAdminSwitchRole,
            );
        }, 500);

        return () => clearTimeout(delayDebounce);
    }, [searchText]);

    useEffect(() => {
        if (role === REVIEWADMIN) {
            fetchAllRSAgencies();
        } else {
            fetchAllFSAgencies();
        }
    }, [role]);

    const fetchAllRSAgencies = async () => {
        try {
            const response = await axios.get(RS_ALL_AGENCIES_API_URL);
            setAgencies(response.data);
        } catch (err) {
            console.error("Error fetching agencies:", err);
        } finally {
        }
    };

    const fetchAllFSAgencies = async () => {
        try {
            const response = await axios.get(GET_FS_ALL_AGENCIES);
            setAgencies(response.data);
        } catch (err) {
            console.error("Error fetching agencies:", err);
        } finally {
        }
    };

    const fetchReport = useCallback(
        async (
            role = role,
            month = selectedMonth,
            carrier = selectedCarrier,
            searchText = searchText,
            selectedAgency = selectedAgency,
            toggleFSRole = toggleAdminSwitchRole,
            sortField = null,
            sortDirection = null,
            filter_by_column_name
        ) => {
            try {
                setLoading(true);

                let endpoint = "";

                if (role === REVIEWADMIN) {
                    endpoint = RS_APPOINTMENT_REPORT;
                } else if (role === EA) {
                    endpoint = FS_APPOINTMENT_REPORT;
                }

                if (!endpoint) return;

                const response = await axios.get(endpoint, {
                    params: {
                        ...(month && { month: month }),
                        ...(carrier && { carrier: carrier }),
                        ...(searchText && { scheduler_name: searchText }),
                        ...(selectedAgency && { agency_id: selectedAgency }),
                        ...(toggleFSRole &&
                            role == EA && {
                            type_of_call: toggleFSRole == LEAD ? PROSPECT : FOLLOWUP,
                        }),
                        ...(sortField && { sort_by: sortField }),
                        ...(sortDirection && { sort_order: sortDirection }),
                        ...(filter_by_column_name && {
                            filter_by_column_name: JSON.stringify(filter_by_column_name)
                        })
                    },
                });

                let responseData = response.data.data.map((item) => ({
                    ...item,
                    ...(carrier ? { type_of_carrier: carrier } : {}),
                    ...(month
                        ? { month: monthOptions.find((m) => m.id == month).name || month }
                        : {}),
                }));

                setRowData(responseData || []);
            } catch (error) {
                console.error("Error fetching report:", error);
            } finally {
                setLoading(false);
            }
        },
        [],
    );


    const columnDefs = useMemo(() => {
        const schedulerHeader =
            role === EA ? FOLLOW_UP_SPECIALIST : REVIEW_SCHEDULER;

        return [
            {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: [schedulerHeader],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "scheduler",
                    sortOrder: sortOrders["scheduler"],
                    handleSort,
                    handleFilter,
                    placeholder: TYPE_TO_FILTER_BY_NAME,
                    showPopOver: true,
                    inputType: "text",
                    handleFilterResetHandler,
                }),
                valueGetter: (params) => `${params.data.scheduler}`,
                sortable: true,
                filter: true,
                autoHeight: true,
            },

            {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Agency"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "agency_name",
                    sortOrder: sortOrders["agency_name"],
                    handleSort,
                    handleFilter,
                    showPopOver: true,
                    inputType: "select",
                    options: agencies,
                    handleFilterResetHandler,
                }),
                valueGetter: (params) => `${params.data.agency_name}`,
                sortable: true,
                filter: true,
                autoHeight: true,
            },
            {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Carrier"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "carrier",
                    sortOrder: sortOrders["carrier"],
                    handleSort,
                    handleFilter,
                    showPopOver: true,
                    inputType: "select",
                    options: carrierOptions,
                    handleFilterResetHandler,
                }),
                valueGetter: (params) => `${params.data.carrier}`,
                sortable: true,
                filter: true,
                autoHeight: true,
            },

            ...(role === REVIEWADMIN
                ? [
                    {
                        headerClass: "custom-ag-header",
                        headerComponent: CustomHeader,
                        headerComponentParams: (params) => ({
                            headers: ["Review List"],
                            colDef: params.column.getColDef(),
                            columnApi: params.columnApi,
                            field: "review_list",
                            sortOrder: sortOrders["review_list"],
                            handleSort,
                            handleFilter,
                            showPopOver: true,
                            inputType: "text",
                            handleFilterResetHandler,
                        }),
                        valueGetter: (params) => `${params.data.review_list}`,
                        sortable: true,
                        filter: true,
                        autoHeight: true,
                    },
                ]
                : []),
            ...(toggleAdminSwitchRole === LEAD && role == EA
                ? [
                    {
                        headerClass: "custom-ag-header",
                        headerComponent: CustomHeader,
                        headerComponentParams: (params) => ({
                            headers: ["Lead List"],
                            colDef: params.column.getColDef(),
                            columnApi: params.columnApi,
                            field: "fs_count",
                            sortOrder: sortOrders["fs_count"],
                            handleSort,
                            handleFilter,
                            showPopOver: true,
                            inputType: "text",
                            handleFilterResetHandler,
                        }),
                        valueGetter: (params) => `${params.data.fs_count}`,
                        sortable: true,
                        filter: true,
                        autoHeight: true,
                    },
                ]
                : []),
            ...(toggleAdminSwitchRole === OPPORTUNITY && role == EA
                ? [
                    {
                        headerClass: "custom-ag-header",
                        headerComponent: CustomHeader,
                        headerComponentParams: (params) => ({
                            headers: ["Opportunity List"],
                            colDef: params.column.getColDef(),
                            columnApi: params.columnApi,
                            field: "fs_count",
                            sortOrder: sortOrders["fs_count"],
                            handleSort,
                            handleFilter,
                            showPopOver: true,
                            inputType: "text",
                            handleFilterResetHandler
                        }),
                        valueGetter: (params) => `${params.data.fs_count}`,
                        sortable: true,
                        filter: true,
                        autoHeight: true,
                    },
                ]
                : []),
            {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Total Calls"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "calls",
                    sortOrder: sortOrders["calls"],
                    handleSort,
                    handleFilter,
                    showPopOver: true,
                    inputType: "text",
                    handleFilterResetHandler
                }),
                valueGetter: (params) => `${params.data.calls}`,
                sortable: true,
                filter: true,
                autoHeight: true,
            },
            {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Total Appointments Scheduled"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "appointments",
                    sortOrder: sortOrders["appointments"],
                    handleSort,
                    handleFilter,
                    showPopOver: true,
                    inputType: "text",
                    handleFilterResetHandler
                }),
                valueGetter: (params) => `${params.data.appointments}`,
                sortable: true,
                filter: true,
                autoHeight: true,
                width: 300,
            },
            {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Percentage"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "call_percentage",
                    sortOrder: sortOrders["call_percentage"],
                    handleSort,
                    handleFilter,
                    showPopOver: true,
                    inputType: "text",
                    handleFilterResetHandler
                }),
                valueGetter: (params) => `${params.data.call_percentage}`,
                sortable: true,
                filter: true,
                autoHeight: true,
            },
            {
                headerClass: "custom-ag-header",
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ["Weekly Stats"],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: "weekly_stats",
                    sortable: false,
                    // sortOrder: sortOrders["weekly_stats"],
                    // handleSort,
                    // handleFilter,
                    // showPopOver: true,
                    // inputType: "text",
                    // handleFilterResetHandler
                }),
                cellRenderer: "arrowIconRenderer",
                sortable: false,
                filter: true,
                autoHeight: true,
            },
        ];
    }, [role, sortOrders, toggleAdminSwitchRole, agencies]);

    const onPageChange = (page) => {
        setCurrentPage(page);
    };
    const handleRoleChange = (newRole) => {
        setRole(newRole);
        console.log("Role changed to:", newRole);
        fetchReport(newRole);
        // Handle role change logic here
    };

    const refresh = () => {
        resetHandlers.current.forEach((reset) => reset());

        setSelectedMonth(moment().format("M"));
        setSelectedCarrier("All Carrier");
        setSearchText("");
        setSelectedAgency(undefined);

        setSearchText("");
        setSelectedAgency(undefined);
        console.log(moment().month(Number(selectedMonth) - 1));
        fetchReport(
            role,
            moment().format("M"),
            "All Carrier",
            "",
            undefined,
            toggleAdminSwitchRole,
        );
    };

    const onGridReady = useCallback((params) => {
        setGridApi(params.api);
        setColumnApi(params.columnApi);
        const savedState = localStorage.getItem("agGridColumnState");
        if (savedState) {
            params.columnApi.applyColumnState({
                state: JSON.parse(savedState),
                applyOrder: true,
            });
        }
    }, []);

    const saveState = useCallback((params) => {
        const state = params.columnApi.getColumnState();
        localStorage.setItem("agGridColumnState", JSON.stringify(state));
    }, []);

    const handleBackToDashboard = () => {
        setSortOrders({});
        setRSFSFilters({
            filter: "",
            direction: "",
        });
        props.history.push("/dashboard");
    };

    return (
        <div>
            <div
                role="button"
                tabIndex="0"
                style={{ marginBottom: "10px" }}
                className="hyperlink-shomore-stat"
                onClick={handleBackToDashboard}
                onMouseEnter={(e) =>
                    (e.currentTarget.style.textDecoration = "underline")
                }
                onMouseLeave={(e) => (e.currentTarget.style.textDecoration = "none")}
                onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleBackToDashboard();
                    }
                }}
            >
                <Icon type="arrow-left" />
                Back to Dashboard
            </div>
            <CommonHeader
                user={props.auth.user}
                onRoleChange={handleRoleChange}
                isHidden={false}
            />
            <div className="rsfs-filters-mobile" style={{ marginTop: "15px" }}>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "10px",
                        width: "100%",
                    }}
                >
                    {/* LEFT SIDE - Selects */}
                    <div style={{ display: "flex", gap: "10px", flex: 1 }}>
                        <Select
                            allowClear
                            showSearch
                            placeholder="Select Month"
                            value={selectedMonth ? selectedMonth : undefined}
                            onChange={(value) => setSelectedMonth(value)}
                            style={{ width: "180px" }}
                            className="dropDown custom-select"
                        >
                            {monthOptions.map((opt) =>
                                opt ? (
                                    <Option key={opt.id} value={opt.id}>
                                        <span style={{ fontSize: "small" }}>{opt.name}</span>
                                    </Option>
                                ) : null,
                            )}
                        </Select>

                        <Select
                            allowClear
                            showSearch
                            placeholder="Select Carrier"
                            value={selectedCarrier ? selectedCarrier : undefined}
                            onChange={(value) => setSelectedCarrier(value)}
                            style={{ width: "180px" }}
                            className="dropDown custom-select"
                        >
                            {carrierOptions.map((opt) =>
                                opt ? (
                                    <Option key={opt.id} value={opt.id}>
                                        <span style={{ fontSize: "small" }}>{opt.name}</span>
                                    </Option>
                                ) : null,
                            )}
                        </Select>
                    </div>

                    {role === EA && (
                        <Col>
                            <Radio.Group
                                defaultValue={toggleAdminSwitchRole}
                                onChange={(e) => handleRoleSwitchChange(e.target.value)}
                            >
                                <Radio.Button
                                    value={LEAD}
                                    className={
                                        toggleAdminSwitchRole === LEAD
                                            ? "review-btn-active"
                                            : "review-btn-inactive"
                                    }
                                    style={{
                                        width: 150,
                                        textAlign: "center",
                                        borderRadius: "20px 0px 0px 20px",
                                    }}
                                >
                                    {LEAD}
                                </Radio.Button>
                                <Radio.Button
                                    value={OPPORTUNITY}
                                    className={
                                        toggleAdminSwitchRole === OPPORTUNITY
                                            ? "ea-btn-active"
                                            : "ea-btn-inactive"
                                    }
                                    style={{
                                        width: 150,
                                        textAlign: "center",
                                        borderRadius: "0px 20px 20px 0px",
                                    }}
                                >
                                    {OPPORTUNITY}
                                </Radio.Button>
                            </Radio.Group>
                        </Col>
                    )}
                    {/* RIGHT SIDE - Reload */}
                    <Button
                        type="primary"
                        className="refresh-con"
                        onClick={() => refresh()}
                        style={{ marginTop: "0px" }}
                    >
                        <Icon type="reload" />
                    </Button>
                </div>
            </div>
            <Card
                type="inner"
                style={{ background: "#FAFAFA" }}
                title={
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                marginRight: "20px",
                            }}
                        >
                            <Icon
                                type="folder"
                                style={{ marginRight: 10, color: "#1890ff" }}
                            />
                            <div
                                style={{ display: "flex", alignItems: "center", gap: "6px" }}
                            >
                                {selectedCarrier && <Translate text={selectedCarrier} />}

                                {selectedCarrier && selectedMonth && <span> - </span>}

                                {selectedMonth && (
                                    <Translate
                                        text={moment()
                                            .month(Number(selectedMonth) - 1)
                                            .format("MMMM")}
                                    />
                                )}
                            </div>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                gap: "40px",
                                overflowX: "auto",
                                gap: "10px",
                                flex: 1,
                            }}
                        >
                            <div style={{ position: "relative", width: "180px" }}>
                                <Input
                                    className="dropDown search-name-input"
                                    placeholder="Search"
                                    value={searchText}
                                    onChange={handleSearch}
                                    style={{ paddingRight: "35px" }}
                                />

                                {searchText ? (
                                    <Icon
                                        type="close"
                                        onClick={() => setSearchText("")}
                                        style={{
                                            position: "absolute",
                                            right: windowWidth <= 769 ? "10px" : "15px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            cursor: "pointer",
                                        }}
                                    />
                                ) : (
                                    <Icon
                                        type="search"
                                        style={{
                                            position: "absolute",
                                            right: windowWidth <= 769 ? "10px" : "15px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                        }}
                                    />
                                )}
                            </div>

                            <Select
                                allowClear
                                showSearch
                                className="dropDown custom-select"
                                placeholder="Search By Agency"
                                optionFilterProp="children"
                                onChange={(value) => setSelectedAgency(value)}
                                filterOption={(input, option) =>
                                    option.props.children &&
                                    option.props.children
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                                value={selectedAgency}
                            >
                                {agencies.map((opt) => (
                                    <Option
                                        key={opt.id}
                                        value={opt.id}
                                        style={{ fontSize: "12px" }}
                                    >
                                        {opt.name}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    </div>
                }
                className="tableCard p_and_c_card"
            >
                {/* Table and loader overlay logic for best popover UX */}
                <div style={{ position: "relative" }}>
                    {columnDefs.length ? (
                        <CustomAgGridTable
                            key={gridKey}
                            rowDatas={rowData}
                            columnDefss={columnDefs}
                            onGridReady={onGridReady}
                            onColumnMoved={saveState}
                            onSortChanged={saveState}
                            onFilterChanged={saveState}
                            frameworkComponents={{
                                CustomHeader,
                                arrowIconRenderer: ArrowIconRenderer,
                            }}
                        />
                    ) : null}
                    {loading && (
                        <div
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background: "rgba(255,255,255,0.6)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: 10,
                            }}
                        >
                            <Spin tip="Loading ..." />
                        </div>
                    )}
                </div>

                <div
                    style={{ float: "right", marginTop: "20px", marginBottom: "20px" }}
                >
                    <Pagination
                        current={currentPage}
                        total={totalPages * pageSize}
                        pageSize={pageSize}
                        showSizeChanger={false}
                        onChange={(page) => onPageChange(page)}
                    />
                </div>
            </Card>
            <WeeklyStatModal
                visible={isModalOpen}
                onClose={handleCloseModal}
                data={modalData}
                role={role}
            />
        </div>
    );
};

export default WeeklyMonthlyReport;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/review-admin/WeeklyMonthlyReport.js